import React, { useEffect, useState, useCallback } from "react";
import { fetchJson } from "../../api";

const GOLD = "#d4a550";
const GOLD_DIM = "rgba(212,165,80,0.15)";
const GOLD_BORDER = "rgba(212,165,80,0.35)";
const SURFACE = "#12121a";
const BORDER = "rgba(255,255,255,0.07)";
const TEXT = "#e8e6df";
const TEXT_DIM = "rgba(232,230,223,0.45)";



function Avatar({ nome, cognome, url, size = 28 }) {
  const initials = `${(nome||"")[0]||""}${(cognome||"")[0]||""}`.toUpperCase();
  if (url) return <img src={url} alt={initials} style={{ width:size,height:size,borderRadius:"50%",objectFit:"cover",flexShrink:0 }} />;
  return <div style={{ width:size,height:size,borderRadius:"50%",background:GOLD_DIM,border:`1px solid ${GOLD_BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:size*0.38,fontWeight:700,color:GOLD,flexShrink:0 }}>{initials||"?"}</div>;
}

function SearchModal({ phaseId, phaseName, resourceNo, planId, productionId, planStart, planEnd, onClose, onSaved }) {
  const [q, setQ] = useState("");
  const [role, setRole] = useState("");
  const [results, setResults] = useState([]);
  const [ruoliDisponibili, setRuoliDisponibili] = useState([]);

  useEffect(() => {
    fetchJson("/postplans/freelancers/roles")
      .then(d => setRuoliDisponibili(d.roles || []))
      .catch(() => {});
  }, []);
  const [selected, setSelected] = useState(null);
  const [manual, setManual] = useState("");
  const [mode, setMode] = useState("search");
  const [saving, setSaving] = useState(false);
  const [rosaItems, setRosaItems] = useState([]);
  const [veterans, setVeterans] = useState([]);

  useEffect(() => {
    const t = setTimeout(async () => {
      try {
        const fromParam = planStart ? `&from=${planStart.slice(0,10)}` : "";
        const toParam = planEnd ? `&to=${planEnd.slice(0,10)}` : "";
        const data = await fetchJson(`/postplans/freelancers/search?q=${encodeURIComponent(q)}&role=${encodeURIComponent(role)}${fromParam}${toParam}`);
        setResults(data.freelancers || []);
      } catch {}
    }, 250);
    return () => clearTimeout(t);
  }, [q, role]);

  useEffect(() => {
    if (mode !== "rosa" || !productionId) return;
    const fromParam = planStart ? `&from=${planStart.slice(0,10)}` : "";
    const toParam = planEnd ? `&to=${planEnd.slice(0,10)}` : "";
    fetchJson(`/postplans/rosa/${productionId}?${fromParam}${toParam}`)
      .then(d => setRosaItems(d.rosa || []))
      .catch(() => {});
    fetchJson("/productions/" + productionId + "/veterans")
      .then(d => setVeterans(d.veterans || [])).catch(() => {});
  }, [mode, productionId]);

  async function confirm() {
    setSaving(true);
    try {
      if (mode === "rosa" && selected) {
        const r = selected;
        const nome = r.nome ? `${r.nome} ${r.cognome||""}`.trim() : r.name_override;
        await fetchJson(`/postplans/${planId}/squad`, {
          method: "PUT",
          body: JSON.stringify({ phaseId, resourceNo, freelancerId: r.freelancer_id||null, nameOverride: nome, label: nome }),
        });
        onSaved(); onClose();
        setSaving(false); return;
      }
      if (mode === "search" && selected) {
        await fetchJson(`/postplans/${planId}/squad`, {
          method: "PUT",
          body: JSON.stringify({ phaseId, resourceNo, freelancerId: selected.id, nameOverride: `${selected.nome} ${selected.cognome}`, label: `${selected.nome} ${selected.cognome}` }),
        });
      } else if (mode === "manual" && manual.trim()) {
        await fetchJson(`/postplans/${planId}/squad`, {
          method: "PUT",
          body: JSON.stringify({ phaseId, resourceNo, nameOverride: manual.trim(), label: manual.trim() }),
        });
      }
      onSaved(); onClose();
    } catch (e) { alert(e.message); }
    finally { setSaving(false); }
  }

  const canConfirm = mode === "rosa" ? !!selected : mode === "search" ? !!selected : !!manual.trim();

  return (
    <div style={{ position:"fixed",inset:0,background:"rgba(0,0,0,0.7)",zIndex:1000,display:"flex",alignItems:"center",justifyContent:"center" }} onClick={onClose}>
      <div style={{ background:SURFACE,border:`1px solid ${BORDER}`,borderRadius:10,width:440,maxHeight:"80vh",display:"flex",flexDirection:"column",overflow:"hidden" }} onClick={e=>e.stopPropagation()}>
        {/* Header */}
        <div style={{ padding:"14px 18px",borderBottom:`1px solid ${BORDER}`,display:"flex",justifyContent:"space-between",alignItems:"center" }}>
          <div>
            <div style={{ fontSize:13,fontWeight:700,color:TEXT }}>{phaseName}</div>
            <div style={{ fontSize:11,color:TEXT_DIM }}>Posizione {resourceNo}</div>
          </div>
          <button onClick={onClose} style={{ background:"none",border:"none",color:TEXT_DIM,cursor:"pointer",fontSize:18 }}>×</button>
        </div>
        {/* Tab */}
        <div style={{ display:"flex",borderBottom:`1px solid ${BORDER}` }}>
          {[["search","Cerca su JKL"],["rosa","Dalla rosa"],["manual","Nome manuale"]].map(([k,l])=>(
            <button key={k} onClick={()=>{setMode(k);setSelected(null);}} style={{ flex:1,padding:"8px",fontSize:12,fontWeight:600,background:"none",border:"none",borderBottom:`2px solid ${mode===k?GOLD:"transparent"}`,color:mode===k?GOLD:TEXT_DIM,cursor:"pointer" }}>{l}</button>
          ))}
        </div>
        {mode==="search" ? (
          <div style={{ display:"flex",flexDirection:"column",flex:1,overflow:"hidden" }}>
            {/* Filtro ruolo */}
            <div style={{ padding:"10px 14px 0",display:"flex",gap:8,flexWrap:"wrap" }}>
            {[...(ruoliDisponibili.some(r=>r.startsWith('Editor Video'))?['Editor Video']:[]),...ruoliDisponibili.filter(r=>!r.startsWith('Editor Video'))].sort((a,b)=>a.localeCompare(b,'it')).map(r=>(<button key={r} onClick={()=>setRole(role===r?'':r)} style={{ padding:'3px 8px',borderRadius:12,fontSize:11,fontWeight:600,cursor:'pointer',border:`1px solid ${role===r?GOLD_BORDER:BORDER}`,background:role===r?GOLD_DIM:'transparent',color:role===r?GOLD:TEXT_DIM }}>{r==='Editor Video'?'Editor Video (tutti)':r}</button>))}
            </div>
            {/* Ricerca nome */}
            <div style={{ padding:"8px 14px" }}>
              <input value={q} onChange={e=>setQ(e.target.value)} placeholder="Cerca per nome…"
                style={{ width:"100%",boxSizing:"border-box",background:"rgba(255,255,255,0.04)",border:`1px solid ${BORDER}`,borderRadius:6,color:TEXT,fontSize:13,padding:"7px 10px",outline:"none" }} autoFocus />
            </div>
            {/* Risultati */}
            <div style={{ overflowY:"auto", scrollbarWidth:"thin", scrollbarColor:"rgba(212,165,80,0.4) transparent",flex:1 }}>
              {results.map(f=>{
                const isSel = selected?.id===f.id;
                return (
                  <div key={f.id} onClick={()=>setSelected(isSel?null:f)}
                    style={{ padding:"10px 14px",display:"flex",alignItems:"center",gap:10,cursor:"pointer",borderBottom:`1px solid ${BORDER}`,background:isSel?"rgba(212,165,80,0.08)":"transparent",borderLeft:isSel?`3px solid ${GOLD}`:"3px solid transparent" }}>
                    <Avatar nome={f.nome} cognome={f.cognome} url={f.profile_image_url||f.avatar_url} />
                    <div style={{ flex:1 }}>
                      <div style={{ fontSize:13,fontWeight:600,color:TEXT }}>{f.nome} {f.cognome}</div>
                      {f.ruoli?.length>0 && <div style={{ fontSize:11,color:TEXT_DIM }}>{f.ruoli.slice(0,3).join(" · ")}</div>}
                      {f.availability==="busy" && <div style={{ fontSize:10,color:"#f87171",marginTop:2 }}>● occupato nel periodo</div>}
                      {f.availability==="free" && f.busy_until && <div style={{ fontSize:10,color:"#fb923c",marginTop:2 }}>⚠ libero fino al {new Date(f.busy_until).toLocaleDateString("it-IT",{day:"2-digit",month:"short"})}</div>}
                      {f.availability==="free" && !f.busy_until && <div style={{ fontSize:10,color:"#4ade80",marginTop:2 }}>● libero per tutto il periodo</div>}
                      {f.availability==="soon" && <div style={{ fontSize:10,color:"#fb923c",marginTop:2 }}>● si libera presto</div>}
                    </div>
                    {isSel && <span style={{ fontSize:12,color:GOLD }}>✓</span>}
                    <span style={{ fontSize:10,color:GOLD,border:`1px solid ${GOLD_BORDER}`,borderRadius:4,padding:"2px 6px" }}>◈ JKL</span>
                  </div>
                );
              })}
              {results.length===0 && <div style={{ padding:16,fontSize:12,color:TEXT_DIM,textAlign:"center" }}>Nessun risultato — prova il nome manuale</div>}
            </div>
          </div>
        ) : mode === "rosa" ? (
          <div style={{ overflowY:"auto", scrollbarWidth:"thin", scrollbarColor:"rgba(212,165,80,0.4) transparent",flex:1 }}>
            {rosaItems.length === 0 && <div style={{ padding:24,textAlign:"center",color:TEXT_DIM,fontSize:13 }}>Rosa vuota — aggiungi persone dalla pagina Squadre</div>}
            {rosaItems.map(r => {
              const isVet = veterans.some(v => String(v.freelancer_id) === String(r.freelancer_id));
              const nome = r.nome ? `${r.nome} ${r.cognome||""}`.trim() : r.name_override;
              const isSel = selected?.id === r.id;
              return (
                <div key={r.id} onClick={()=>setSelected(isSel?null:r)}
                  style={{ padding:"10px 14px",display:"flex",alignItems:"center",gap:10,cursor:"pointer",borderBottom:`1px solid ${BORDER}`,background:isSel?"rgba(212,165,80,0.08)":"transparent",borderLeft:isSel?`3px solid ${GOLD}`:"3px solid transparent" }}>
                  <div style={{ width:28,height:28,borderRadius:"50%",background:GOLD_DIM,border:`1px solid ${GOLD_BORDER}`,display:"flex",alignItems:"center",justifyContent:"center",fontSize:10,fontWeight:700,color:GOLD,flexShrink:0 }}>
                    {(nome[0]||"").toUpperCase()}
                  </div>
                  <div style={{ flex:1 }}>
                    <div style={{ fontSize:13,fontWeight:600,color:TEXT }}>{nome}</div>
                    <div style={{ fontSize:11,color:TEXT_DIM }}>{(r.ruoli||[])[0]||r.ruolo||"—"}</div>
                    {r.freelancer_id && r.availability === "busy" && <div style={{ fontSize:10,color:"#f87171",marginTop:2 }}>● occupato nel periodo</div>}
                    {r.freelancer_id && r.availability === "soon" && <div style={{ fontSize:10,color:"#fb923c",marginTop:2 }}>● si libera presto</div>}
                    {r.freelancer_id && r.availability === "free" && r.busy_until && <div style={{ fontSize:10,color:"#fb923c",marginTop:2 }}>⚠ libero fino al {new Date(r.busy_until).toLocaleDateString("it-IT",{day:"2-digit",month:"short"})}</div>}
                    {r.freelancer_id && r.availability === "free" && !r.busy_until && <div style={{ fontSize:10,color:"#4ade80",marginTop:2 }}>● libero per tutto il periodo</div>}
                  </div>
                  {r.freelancer_id && <span style={{ fontSize:10,color:GOLD,border:`1px solid ${GOLD_BORDER}`,borderRadius:4,padding:"1px 5px" }}>◈ JKL</span>}
                  {isVet && <span style={{ fontSize:10,color:'#f0c878',border:'1px solid rgba(240,200,120,0.35)',borderRadius:4,padding:"1px 5px" }}>⭐ vet</span>}
                  {isSel && <span style={{ color:GOLD,fontSize:13 }}>✓</span>}
                </div>
              );
            })}
          </div>
        ) : (
          <div style={{ padding:16,display:"flex",flexDirection:"column",gap:12 }}>
            <div style={{ fontSize:12,color:GOLD,background:"rgba(212,165,80,0.06)",border:`1px solid ${GOLD_BORDER}`,borderRadius:6,padding:"8px 12px" }}>
              Per le metriche di performance usa preferibilmente un iscritto JKL
            </div>
            <input value={manual} onChange={e=>setManual(e.target.value)} placeholder="Es. Mario Rossi"
              style={{ background:"rgba(255,255,255,0.04)",border:`1px solid ${BORDER}`,borderRadius:6,color:TEXT,fontSize:13,padding:"7px 10px",outline:"none" }} autoFocus />
          </div>
        )}
        {/* Footer conferma */}
        <div style={{ padding:"12px 16px",borderTop:`1px solid ${BORDER}`,display:"flex",justifyContent:"flex-end",gap:8 }}>
          <button onClick={onClose} style={{ background:"none",border:`1px solid ${BORDER}`,borderRadius:6,color:TEXT_DIM,fontSize:13,padding:"7px 14px",cursor:"pointer" }}>Annulla</button>
          <button onClick={confirm} disabled={!canConfirm||saving} style={{ background:canConfirm?GOLD_DIM:"rgba(255,255,255,0.04)",border:`1px solid ${canConfirm?GOLD_BORDER:BORDER}`,borderRadius:6,color:canConfirm?GOLD:TEXT_DIM,fontSize:13,fontWeight:600,padding:"7px 16px",cursor:canConfirm?"pointer":"not-allowed",opacity:saving?0.6:1 }}>
            {saving?"Salvataggio…":"Conferma"}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function SquadPanel({ planId, productionId, planStart, planEnd, onClose }) {
  const [phases, setPhases] = useState([]);
  const MILESTONE_TYPES = new Set(['vis_autore','mod_autore','vis_rete','mod_rete','master']);
  const [squad, setSquad] = useState([]);
  const [modal, setModal] = useState(null);
  const [loading, setLoading] = useState(true);
  const [rosa, setRosa] = useState([]);
  const [showRosa, setShowRosa] = useState(false);

  const load = useCallback(async () => {
    try {
      const [planData, squadData] = await Promise.all([
        fetchJson(`/postplans/${planId}/timeline`),
        fetchJson(`/postplans/${planId}/squad`),
      ]);
      const phaseMap = new Map();
      (planData.blocksFlat || []).forEach(b => {
        if (!phaseMap.has(b.phaseId)) {
          phaseMap.set(b.phaseId, { id: b.phaseId, name: b.phaseName, typeKey: b.phaseTypeKey||"", sortOrder: b.phaseSortOrder??999, lines: 0 });
        }
        const p = phaseMap.get(b.phaseId);
        if (b.lineNo > p.lines) p.lines = b.lineNo;
      });
      setPhases([...phaseMap.values()]
        .filter(p => !p.name.toLowerCase().includes("visione"))
        .sort((a,b)=>a.sortOrder-b.sortOrder));
      setSquad(squadData.squad || []);
    } catch(e){ console.error(e); }
    finally { setLoading(false); }
  }, [planId]);

  useEffect(()=>{ load(); },[load]);

  async function caricaRosa() {
    console.log("[caricaRosa] productionId:", productionId);
    if (!productionId) { console.log("[caricaRosa] no productionId, abort"); return; }
    try {
      const d = await fetchJson("/postplans/rosa/" + productionId);
      console.log("[caricaRosa] risposta:", d);
      setRosa(d.rosa || []);
      setShowRosa(true);
      console.log("[caricaRosa] showRosa impostato a true, rosa:", d.rosa?.length);
    } catch(e) { console.error(e); }
  }

  async function assegnaFromRosa(person, phaseId, phaseName, resourceNo) {
    try {
      await fetchJson("/postplans/" + planId + "/squad", {
        method: "PUT",
        body: JSON.stringify({
          phaseId, resourceNo,
          freelancerId: person.freelancer_id || null,
          nameOverride: person.nome ? (person.nome + " " + (person.cognome||"")).trim() : person.name_override,
          label: person.nome ? (person.nome + " " + (person.cognome||"")).trim() : person.name_override,
        }),
      });
      load();
      setShowRosa(false);
    } catch(e) { alert(e.message); }
  }

  function getResource(phaseId, resourceNo) {
    return squad.find(r => Number(r.phase_id)===Number(phaseId) && Number(r.resource_no)===Number(resourceNo));
  }

  async function removeResource(resourceId) {
    try {
      await fetchJson(`/postplans/${planId}/squad/${resourceId}`, { method:"DELETE" });
      load();
    } catch(e){ alert(e.message); }
  }

  if (loading) return <div style={{ display:"flex",alignItems:"center",justifyContent:"center",height:200,color:TEXT_DIM,fontSize:13 }}>Caricamento squadra…</div>;

  return (
    <div style={{ background:"#0a0a0f",color:TEXT,fontFamily:"'Kanit','Inter',sans-serif",height:"100%",display:"flex",flexDirection:"column" }}>
      {modal && <SearchModal {...modal} planId={planId} productionId={productionId} planStart={planStart} planEnd={planEnd} onClose={()=>setModal(null)} onSaved={load} />}
      <div style={{ padding:"14px 20px",borderBottom:`1px solid ${BORDER}`,display:"flex",justifyContent:"space-between",alignItems:"center" }}>
        <div style={{ fontSize:15,fontWeight:700,color:GOLD }}>Squadra</div>
        <div style={{ display:"flex",gap:8 }}>

          <button onClick={onClose} style={{ background:"rgba(255,255,255,0.06)",border:`1px solid ${BORDER}`,borderRadius:6,color:TEXT,cursor:"pointer",fontSize:13,fontWeight:600,padding:"5px 12px" }}>✕ Chiudi</button>
        </div>
      </div>

      <div style={{ overflowY:"auto", scrollbarWidth:"thin", scrollbarColor:"rgba(212,165,80,0.4) transparent",flex:1,padding:"12px 0" }}>
        {phases.map(phase=>{
          const slots = Array.from({length:phase.lines},(_,i)=>i+1);
          if (MILESTONE_TYPES.has(phase.typeKey)) return null;
          return (
            <div key={phase.id} style={{ borderBottom:`1px solid ${BORDER}`,padding:"10px 20px" }}>
              <div style={{ fontSize:11,fontWeight:600,color:TEXT_DIM,letterSpacing:"0.06em",textTransform:"uppercase",marginBottom:8 }}>{phase.name}</div>
              {(
              <div style={{ display:"flex",flexDirection:"column",gap:6 }}>
                {slots.map(rno=>{
                  const res = getResource(phase.id, rno);
                  return (
                    <div key={rno} style={{ display:"flex",alignItems:"center",gap:10 }}>
                      {res ? (
                        <>
                          <Avatar nome={res.nome||res.name_override} cognome={res.cognome||""} url={res.profile_image_url||res.avatar_url} size={26} />
                          <span style={{ fontSize:13,color:TEXT,flex:1 }}>{res.nome?`${res.nome} ${res.cognome}`:res.name_override}</span>
                          {res.freelancer_id && <span style={{ fontSize:10,color:GOLD,border:`1px solid ${GOLD_BORDER}`,borderRadius:4,padding:"2px 6px" }}>◈ JKL</span>}
                          <button onClick={()=>removeResource(res.id)} style={{ background:"none",border:"none",color:"rgba(239,68,68,0.5)",cursor:"pointer",fontSize:14,padding:"0 4px" }}>×</button>
                        </>
                      ) : (
                        <button onClick={()=>setModal({phaseId:phase.id,phaseName:phase.name,resourceNo:rno})}
                          style={{ display:"flex",alignItems:"center",gap:8,background:"rgba(255,255,255,0.03)",border:`1px dashed ${BORDER}`,borderRadius:6,padding:"5px 10px",cursor:"pointer",color:TEXT_DIM,fontSize:12,width:"100%" }}>
                          <span style={{ fontSize:16,lineHeight:1 }}>+</span>
                          {phase.lines>1 ? `Aggiungi persona (linea ${rno})` : "Aggiungi persona"}
                        </button>
                      )}
                    </div>
                  );
                })}
              </div>
              )}
            </div>
          );
        })}
      </div>
    </div>
  );
}
